import L from "leaflet";
import LocationIcon from "../../../utils/icons/location_on.svg";

const MarkerIcon = new L.Icon({
  iconUrl: LocationIcon,
  iconRetinaUrl: LocationIcon,
  popupAnchor: [-0, -0],
  iconSize: [32, 45],
});

export { MarkerIcon };
